import React, { useState } from 'react';
import { adminLogin } from '../api';
import './Admin.css';

export default function AdminLogin({ onLogin }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await adminLogin(password);
      localStorage.setItem('admin_token', data.token);
      onLogin(data.token);
    } catch (err) {
      setError(err.message || 'Invalid password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page" data-testid="admin-login-page">
      <div className="admin-login-card">
        <div className="admin-login-brand">
          <span className="admin-brand-circle">circle</span>
          <span className="admin-brand-studios">Studios</span>
        </div>
        <h1 className="admin-login-title">Admin Panel</h1>
        <p className="admin-login-sub">Enter your password to manage site content</p>
        <form onSubmit={handleSubmit} data-testid="admin-login-form">
          <input
            type="password"
            className="admin-input"
            placeholder="Enter admin password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
            data-testid="admin-password-input"
          />
          {error && <p className="admin-error" data-testid="admin-login-error">{error}</p>}
          <button
            type="submit"
            className="admin-login-btn"
            disabled={loading || !password}
            data-testid="admin-login-btn"
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
